/**
 * @generated SignedSource<<4e6bafa68728bad43007549fed1d8143>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlansListRefactored$data = {
  readonly jira: {
    readonly favouritePlans: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly planId?: AGG$Long | null | undefined;
          readonly title?: string | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItemRefactored">;
        };
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly recentPlans: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly planId?: AGG$Long | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItemRefactored">;
        };
      } | null | undefined> | null | undefined;
    };
  };
  readonly plansOrder: {
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null | undefined;
        readonly visible: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PlansListRefactored";
} | null | undefined;
export type PlansListRefactored$key = {
  readonly " $data"?: PlansListRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlansListRefactored">;
};

import PlansListRefactoredQuery_graphql from './PlansListRefactoredQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "planId"
},
v3 = {
  "kind": "FragmentSpread",
  "name": "PlanMenuItemRefactored"
},
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURLPath"
    },
    {
      "kind": "RootArgument",
      "name": "entityAriPlans"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": PlansListRefactoredQuery_graphql
    }
  },
  "name": "PlansListRefactored",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "favouritePlans",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "sort": {
                      "order": "DESC"
                    },
                    "type": "PLAN"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 15
                }
              ],
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                },
                {
                  "concreteType": "JiraFavouriteEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v1/*: any*/),
                                "action": "LOG",
                                "path": "jira.favouritePlans.edges.node.id"
                              },
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              (v3/*: any*/)
                            ],
                            "type": "JiraPlan"
                          }
                        ]
                      },
                      "action": "LOG",
                      "path": "jira.favouritePlans.edges.node"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "LOG",
            "path": "jira.favouritePlans"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "recentPlans",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "currentURL",
                  "variableName": "currentURLPath"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                },
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "PLAN"
                  ]
                }
              ],
              "concreteType": "JiraSearchableEntityConnection",
              "kind": "LinkedField",
              "name": "recentItems",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraSearchableEntityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v1/*: any*/),
                                "action": "LOG",
                                "path": "jira.recentPlans.edges.node.id"
                              },
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "type": "JiraPlan"
                          }
                        ]
                      },
                      "action": "LOG",
                      "path": "jira.recentPlans.edges.node"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "LOG",
            "path": "jira.recentPlans"
          }
        ]
      },
      "action": "LOG",
      "path": "jira"
    },
    {
      "alias": "plansOrder",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "entityAriPlans"
        },
        {
          "kind": "Variable",
          "name": "ownerAri",
          "variableName": "ownerAri"
        }
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItemConnection",
          "kind": "LinkedField",
          "name": "sidebar",
          "plural": false,
          "selections": [
            {
              "concreteType": "SettingsMenuItem",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "menuId"
                },
                {
                  "kind": "ScalarField",
                  "name": "visible"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "2ddac3dbb3259d27dc6f11175b355784";

export default node;
